(function () {
  const SECTION_SELECTOR = ".featured-blog-wordpress";

  const parseBoolean = (value) => value === "true";

  const escapeHtml = (value) =>
    String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");

  const decodeHtml = (value) => {
    const textarea = document.createElement("textarea");
    textarea.innerHTML = value || "";
    return textarea.value;
  };

  const stripHtml = (value) => {
    const temp = document.createElement("div");
    temp.innerHTML = value || "";
    return (temp.textContent || temp.innerText || "").trim();
  };

  const truncate = (value, maxLength) => {
    if (value.length <= maxLength) return value;
    return `${value.slice(0, maxLength).trim()}...`;
  };

  const formatDate = (value) => {
    if (!value) return "";

    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return "";

    return new Intl.DateTimeFormat("pt-BR").format(date);
  };

  const deriveTags = (post) => {
    const terms = post?._embedded?.["wp:term"];
    if (!Array.isArray(terms)) return [];

    const seen = new Set();

    return terms
      .flat()
      .filter((term) => term && term.name)
      .map((term) => ({
        name: term.name,
        link: term.link || "",
      }))
      .filter((term) => {
        if (seen.has(term.name)) return false;
        seen.add(term.name);
        return true;
      });
  };

  const normalizePost = (post) => {
    const title = decodeHtml(post?.title?.rendered || "");
    const excerpt = stripHtml(post?.excerpt?.rendered || "");
    const featuredMedia = post?._embedded?.["wp:featuredmedia"]?.[0];
    const author = post?._embedded?.author?.[0];

    return {
      id: post?.id || `wp-post-${Math.random().toString(36).slice(2)}`,
      title,
      link: post?.link || "#",
      excerpt: truncate(excerpt, 150),
      date: formatDate(post?.date),
      image: featuredMedia?.source_url || "",
      imageAlt: decodeHtml(featuredMedia?.alt_text || title),
      author: author?.name || "",
      tags: deriveTags(post),
    };
  };

  const getWrapperTag = (config) =>
    config.postLayout === "grid" ? "li" : "div";

  const buildTagsMarkup = (tags, config) => {
    if (!config.showTags || !tags.length) return "";

    const items = tags
      .map((tag) => {
        const inner = tag.link
          ? `<a href="${escapeHtml(tag.link)}" ${
              config.overlay || config.backgroundCard
                ? `class="${config.cardColorScheme}"`
                : ""
            }><span title="${escapeHtml(tag.name)}">${escapeHtml(tag.name)}</span></a>`
          : `<div ${
              config.overlay || config.backgroundCard
                ? `class="${config.cardColorScheme}"`
                : ""
            }><span title="${escapeHtml(tag.name)}">${escapeHtml(tag.name)}</span></div>`;

        return `<li class="article-card__tag body-small ${
          config.showImage ? "color-background-1" : ""
        }">${inner}</li>`;
      })
      .join("");

    return `<ul class="article-card__tags">${items}</ul>`;
  };

  const buildAuthorMarkup = (post, config) => {
    if (!config.showAuthor && !config.showDate) return "";
    if (!post.author && !post.date) return "";

    const authorImage =
      config.authorImage && config.showAuthor
        ? `<div class="article-card__author-image">
          <img src="${escapeHtml(config.authorImage)}" alt="${escapeHtml(post.author || "Autor")}" loading="lazy" width="50" height="50">
        </div>`
        : "";

    const authorName =
      config.showAuthor && post.author
        ? `<span class="article-card__author-name">${escapeHtml(post.author)}</span>`
        : "";

    const date =
      config.showDate && post.date
        ? `<span class="article-card__date body-small">Publicado em ${escapeHtml(post.date)}</span>`
        : "";

    return `
      <div class="article-card__author">
        ${authorImage}
        <div class="article-card__author-info">
          ${authorName}
          <div class="article-card__meta">
            ${date}
          </div>
        </div>
      </div>
    `;
  };

  const buildCardMarkup = (post, config) => {
    const imageMarkup =
      config.showImage && post.image
        ? `<div class="article-card__image media">
          <img src="${escapeHtml(post.image)}" alt="${escapeHtml(post.imageAlt)}" loading="lazy">
        </div>`
        : "";

    const tagsMarkup = buildTagsMarkup(post.tags, config);
    const excerptMarkup = post.excerpt
      ? `<p class="article-card__excerpt">${escapeHtml(post.excerpt)}</p>`
      : "";

    const beforeContentTags = config.overlay ? "" : tagsMarkup;
    const insideContentTags = config.overlay ? tagsMarkup : "";

    return `
      <article
        class="article-card article-card--${escapeHtml(config.imageRatio)} ${
          config.overlay ? "article-card--overlay" : ""
        } ${config.backgroundCard || config.overlay ? config.cardColorScheme : ""}"
        aria-labelledby="Article-${escapeHtml(post.id)}"
      >
        ${imageMarkup}
        ${beforeContentTags}
        <div class="article-content motion-reduce ${
          config.backgroundCard || config.overlay
            ? "article-content--background"
            : ""
        }">
          <div class="article-card__info">
            ${insideContentTags}
            <header class="article-card__header">
              <h2
                class="article-card__title ${escapeHtml(config.postHeadingSize || "h5")}"
                id="Article-${escapeHtml(post.id)}"
              >
                <a href="${escapeHtml(post.link)}">${escapeHtml(post.title)}</a>
              </h2>
              ${excerptMarkup}
            </header>
            <div class="article-card__bottom">
              ${buildAuthorMarkup(post, config)}
            </div>
          </div>
        </div>
        <a class="article-card-link" href="${escapeHtml(post.link)}" aria-label="${escapeHtml(post.title)}"></a>
      </article>
    `;
  };

  const buildSlideMarkup = (post, config) => {
    const tagName = getWrapperTag(config);
    const slideClass =
      config.enableCarousel && config.postLayout !== "grid"
        ? "swiper-slide "
        : "";

    return `
      <${tagName} class="${slideClass}blog__post article">
        ${buildCardMarkup(post, config)}
      </${tagName}>
    `;
  };

  const renderStatus = (container, config, message) => {
    const tagName = getWrapperTag(config);
    container.innerHTML = `<${tagName} class="blog__post article featured-blog-wordpress__status">${escapeHtml(message)}</${tagName}>`;
  };

  const initSlider = (root) => {
    const slider = root.querySelector(".blog__slider");
    if (!slider || !window.Swiper) return;

    if (slider.swiper) {
      slider.swiper.destroy(true, true);
    }

    const navigation = root.querySelector(".blog__navigation");
    const pagination = root.querySelector(".blog__pagination");
    const columns = Number(slider.dataset.columns || 1);
    const columns1200 = columns === 4 ? columns - 1 : columns;
    const columns990 = columns > 3 ? columns - 1 : columns;
    const columns576 = columns > 2 ? columns990 - 1 : columns990;

    new Swiper(slider, {
      slidesPerView: 1,
      spaceBetween: 24,
      mousewheel: {
        forceToAxis: true,
      },
      speed: 1000,
      navigation: navigation
        ? {
            nextEl: navigation.querySelector(".swiper-button-next"),
            prevEl: navigation.querySelector(".swiper-button-prev"),
          }
        : undefined,
      pagination: pagination
        ? {
            el: pagination,
            type: "bullets",
            clickable: true,
          }
        : undefined,
      breakpoints: {
        576: {
          slidesPerView: columns576,
          slidesPerGroup: columns576,
        },
        990: {
          slidesPerView: columns990,
          slidesPerGroup: columns990,
        },
        1200: {
          slidesPerView: columns1200,
          slidesPerGroup: columns1200,
        },
        1360: {
          slidesPerView: columns,
          slidesPerGroup: columns,
        },
      },
    });
  };

  const getConfig = (root) => ({
    apiUrl: root.dataset.apiUrl,
    postLimit: Number(root.dataset.postLimit || 0),
    postLayout: root.dataset.postLayout,
    columns: Number(root.dataset.columns || 1),
    enableCarousel: parseBoolean(root.dataset.enableCarousel),
    backgroundCard: parseBoolean(root.dataset.backgroundCard),
    imageRatio: root.dataset.imageRatio || "landscape",
    postHeadingSize: root.dataset.postHeadingSize || "h5",
    showImage: parseBoolean(root.dataset.showImage),
    showTags: parseBoolean(root.dataset.showTags),
    showDate: parseBoolean(root.dataset.showDate),
    showAuthor: parseBoolean(root.dataset.showAuthor),
    showExcerpt: parseBoolean(root.dataset.showExcerpt),
    cardColorScheme: root.dataset.cardColorScheme || "",
    authorImage: root.dataset.authorImage || "",
    loadingText: root.dataset.loadingText || "Carregando posts...",
    emptyText: root.dataset.emptyText || "Nenhum post encontrado.",
    errorText:
      root.dataset.errorText ||
      "Nao foi possivel carregar os posts no momento.",
    overlay: root.dataset.postLayout === "overlay",
  });

  const renderPosts = (root, posts) => {
    const config = getConfig(root);
    const container = root.querySelector("[data-featured-blog-posts]");

    if (!container) return;

    if (!posts.length) {
      renderStatus(container, config, config.emptyText);
      return;
    }

    container.innerHTML = posts
      .map((post) => buildSlideMarkup(post, config))
      .join("");
    initSlider(root);
  };

  const fetchPosts = async (root) => {
    const config = getConfig(root);
    const container = root.querySelector("[data-featured-blog-posts]");
    if (!container) return;

    renderStatus(container, config, config.loadingText);

    if (!config.apiUrl) {
      renderStatus(container, config, config.errorText);
      return;
    }

    try {
      const response = await fetch(config.apiUrl, {
        headers: {
          Accept: "application/json",
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }

      const data = await response.json();
      const posts = Array.isArray(data)
        ? data.slice(0, config.postLimit).map(normalizePost)
        : [];

      renderPosts(root, posts);
    } catch (error) {
      console.error("[featured-blog-wordpress] Erro ao carregar posts", error);
      renderStatus(container, config, config.errorText);
    }
  };

  const initSection = (root) => {
    if (!root) return;
    fetchPosts(root);
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll(SECTION_SELECTOR).forEach(initSection);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initAll());
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", (event) => {
    initAll(event.target);
  });
})();
